import React from "react"
import Img from "gatsby-image"

import Header from "@layouts/header"
import Footer from "@layouts/footer"
import SEO from "@layouts/seo"
import GlobalStyles from "@layouts/styles"

import { ToTopButton } from "@components/button"

const Layout = ({ children, image, title }) => (
  <>
    <GlobalStyles />
    <SEO title={title} />
    <Header />
    <main>
      {image && <Img fluid={image} alt="" />}
      {children}
    </main>
    <Footer />
    <ToTopButton step={50} delay={16.66} />
  </>
)

export default Layout
